/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Field/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaInputQuestion from 'DesignSystem/TysiaInputQuestion/index'



/** @type {import('Simple/types.js').View} */
export default function Field({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Expanded/Content/TreatmentFields/Content/Field"
  
}) {
let eventAppointmentValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment',
format: fromFormat.isAppointmentBookingLocked,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaInputQuestion
  viewPath={`${viewPath}/TysiaInputQuestion`}
 size="small"
 maxWidth={100}
 marginRight={dtSpaceXs}
 marginTop={dtSpaceXxs}
 data="event.appointment"
 format="/Data/format.js isAppointmentBookingLocked"
 disabled={eventAppointmentValueData}
/>
{children}
</React.Fragment>)
}